// "marca" toma los colores de la instalación (BRAND_COLOR en el .env, ver
// marca.tsx); las demás son fijas. Todas conservan el acento secundario de la
// marca para que la identidad no se pierda al cambiar de color.

export type ModoTema = 'claro' | 'oscuro' | 'sistema';
export type Paleta = 'marca' | 'verde' | 'grafito' | 'indigo';

export const PALETAS: Array<{ id: Paleta; nombre: string; muestra: string }> = [
  { id: 'marca', nombre: 'Institucional', muestra: 'var(--marca-primario)' },
  { id: 'verde', nombre: 'Verde', muestra: '#82BB3B' },
  { id: 'grafito', nombre: 'Grafito', muestra: '#3F4A54' },
  { id: 'indigo', nombre: 'Índigo', muestra: '#4C4FBF' },
];

const ACENTOS: Record<Paleta, { claro: string; oscuro: string }> = {
  marca: { claro: 'var(--marca-primario)', oscuro: 'var(--marca-primario-oscuro)' },
  verde: { claro: '#5A8F1F', oscuro: '#9BD154' },
  grafito: { claro: '#3F4A54', oscuro: '#9FB0BE' },
  indigo: { claro: '#4C4FBF', oscuro: '#9497F0' },
};

/** El tema se guarda en el perfil del usuario con el formato "modo:paleta". */
export function parseTema(valor: string | undefined): { modo: ModoTema; paleta: Paleta } {
  const [modo, paleta] = (valor ?? '').split(':');
  return {
    modo: modo === 'claro' || modo === 'oscuro' || modo === 'sistema' ? modo : 'sistema',
    // Lo desconocido (incluido el "edelar" de antes) cae en la paleta de la marca.
    paleta: (PALETAS.some((p) => p.id === paleta) ? paleta : 'marca') as Paleta,
  };
}

export function serializarTema(modo: ModoTema, paleta: Paleta): string {
  return `${modo}:${paleta}`;
}

const CLAVE_LOCAL = 'cloud.tema';

/**
 * El tema vive en el perfil para seguir al usuario entre navegadores, pero se
 * espeja acá para poder pintarlo antes de que responda /me y evitar el
 * parpadeo de cargar con el tema equivocado.
 */
export function temaGuardadoLocal(): string | undefined {
  try {
    return localStorage.getItem(CLAVE_LOCAL) ?? undefined;
  } catch {
    return undefined;
  }
}

export function aplicarTema(modo: ModoTema, paleta: Paleta): void {
  const oscuro =
    modo === 'oscuro' ||
    (modo === 'sistema' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  const root = document.documentElement;
  root.dataset.tema = oscuro ? 'oscuro' : 'claro';
  root.style.setProperty('--acento', ACENTOS[paleta][oscuro ? 'oscuro' : 'claro']);

  try {
    localStorage.setItem(CLAVE_LOCAL, serializarTema(modo, paleta));
  } catch {
    // Modo privado o almacenamiento bloqueado: el tema igual quedó aplicado.
  }
}
